import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const teamMembers1 = [
  {
    icon: "/images/AboutUs/Professionals/Search-Engine-Optimizers.svg",
    hoverIcon:
      "/images/AboutUs/Professionals/Search-Engine-Optimizers-Hover.svg",
    label: "Search Engine Optimizers",
  },
  {
    icon: "/images/AboutUs/Professionals/Designers.svg",
    hoverIcon: "/images/AboutUs/Professionals/Designers-Hover.svg",
    label: "Designers",
  },
  {
    icon: "/images/AboutUs/Professionals/DevOps-Engineers.svg",
    hoverIcon: "/images/AboutUs/Professionals/DevOps-Engineers-Hover.svg",
    label: "DevOps Engineers",
  },
  {
    icon: "/images/AboutUs/Professionals/Domain&Host-Managers.svg",
    hoverIcon: "/images/AboutUs/Professionals/Domain&Host-Managers-Hover.svg",
    label: "Domain & Host Managers",
  },
];

const teamMembers2 = [
  {
    icon: "/images/AboutUs/Professionals/Programmers.svg",
    hoverIcon: "/images/AboutUs/Professionals/Programmers-Hover.svg",
    label: "Programmers",
  },
  {
    icon: "/images/AboutUs/Professionals/Digital-Marketers.svg",
    hoverIcon: "/images/AboutUs/Professionals/Digital-Marketers-Hover.svg",
    label: "Digital Marketers",
  },
  {
    icon: "/images/AboutUs/Professionals/Scrum-Masters.svg",
    hoverIcon: "/images/AboutUs/Professionals/Scrum-Masters-Hover.svg",
    label: "Scrum Masters",
  },
  {
    icon: "/images/AboutUs/Professionals/More.svg",
    hoverIcon: "",
    label: "More",
  },
];

function DedicatedTeam() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const { ref, inView } = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  // Animation controls
  const headerControls = useAnimation();
  const cardControls1 = useAnimation();
  const cardControls2 = useAnimation();
  const cardControls3 = useAnimation();
  const cardControls4 = useAnimation();
  const cardControls5 = useAnimation();
  const cardControls6 = useAnimation();
  const cardControls7 = useAnimation();

  const allCardControls = [
    cardControls1,
    cardControls2,
    cardControls3,
    cardControls4,
    cardControls5,
    cardControls6,
    cardControls7,
  ];

  useEffect(() => {
    const runSequence = async () => {
      if (inView && !isMobile) {
        // Animate header first
        await headerControls.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.25, ease: "easeOut" }, // faster
        });

        // Animate cards one-by-one faster
        for (let i = 0; i < allCardControls.length; i++) {
          await allCardControls[i].start({
            y: 0,
            opacity: 1,
            transition: { duration: 0.25, ease: "easeOut" }, // faster
          });
        }
      }
    };

    runSequence();
  }, [inView, isMobile, headerControls, allCardControls]);

  const renderCard = (val, idx, colSize) => (
    <div className={`col-${colSize}`} key={idx}>
      <div
        className="d-flex justify-content-center align-items-center flex-column dedicated-team-card"
        onMouseEnter={() => setHoveredIndex(idx)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <img
          src={
            isMobile
              ? val.icon
              : hoveredIndex === idx && val.hoverIcon
              ? val.hoverIcon
              : val.icon
          }
          alt={val.label}
          className="dedicated-team-card-img"
        />
        <h3 className="mt-4 text-center dedicated-team-card-h3">{val.label}</h3>
      </div>
    </div>
  );

  return (
    <div ref={ref} className="row py-md-5 py-2 mx-3_5-0">
      <div className="col-12 px-3">
        {isMobile ? (
          <h2 className="about-heading">
            Dedicated Team of Talented Professionals
          </h2>
        ) : (
          <motion.h2
            className="about-heading"
            initial={{ y: -50, opacity: 0 }}
            animate={headerControls}
          >
            Dedicated Team of Talented Professionals
          </motion.h2>
        )}
      </div>

      <div className="col-12 px-md-3 px-4">
        <div className="row zigzag-row">
          {isMobile
            ? teamMembers1.map((val, idx) => renderCard(val, idx, 6))
            : teamMembers1.map((val, idx) => (
                <motion.div
                  key={idx}
                  initial={{ y: 80, opacity: 0 }}
                  animate={allCardControls[idx]}
                  className="col-3"
                >
                  {renderCard(val, idx, 12)}
                </motion.div>
              ))}
        </div>

        <div className="row justify-content-center zigzag-row">
          {isMobile
            ? teamMembers2.map((val, idx) =>
                renderCard(val, idx + teamMembers1.length, 6)
              )
            : teamMembers2
                .filter((member) => member.label !== "More")
                .map((val, idx) => {
                  const index = idx + teamMembers1.length;
                  return (
                    <motion.div
                      key={index}
                      initial={{ y: 80, opacity: 0 }}
                      animate={allCardControls[index]}
                      className="col-3"
                    >
                      {renderCard(val, index, 12)}
                    </motion.div>
                  );
                })}
        </div>
      </div>
    </div>
  );
}

export default DedicatedTeam;
